import { LOCAL_STORAGE_KEYS, ROUTES } from './constants';
import { useState, useCallback } from 'react';
import axios from 'axios';
import { message } from 'antd';
/**
 * useAuthApi - Common hook for authenticated API calls with loading, data, error, and token in header.
 * @returns {Object} { data, error, loading, callApi }
 * Usage:
 *   const { data, error, loading, callApi } = useAuthApi();
 *   callApi('get', '/api/secure-endpoint');
 */

export const MethodType = {
    GET: "get",
    POST: "post",
    PUT: "put",
    DELETE: "delete",
}

export const axiosCall = axios.create({
    baseURL: process.env.REACT_APP_MAIN_SERVER_URL,
    timeout: 10000,
});

// Request interceptor to add auth token
axiosCall.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
axiosCall.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Handle unauthorized access
            localStorage.clear();
            window.location.href = ROUTES.LOGIN;
        }
        return Promise.reject(error);
    }
);

export function useApi() {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const callApi = useCallback(
        async (method, url, payload = null, params = null, config = null) => {
            setLoading(true);
            setError(null);
            try {
                const response = await axiosCall({
                    method,
                    url,
                    headers: {
                        ...(config?.headers || {}),
                    },
                    ...(method.toLowerCase() === 'get'
                        ? { params }
                        : { params, data: payload }),
                    ...config,
                });
                setData(response.data);
                return response.data;
            } catch (err) {
                setError(err);
                message.error(
                    err?.response?.data?.message || err.message || 'API Error'
                );
                return null;
            } finally {
                setLoading(false);
            }
        },
        []
    );

    return { callApi, loading, error, data };
}


/* 
export async function authAxios(method, url, payload = null) {
    return new Promise(async (resolve, reject) => {
        try {
            let response = await axios({
                method: method,
                // url: `${process.env.NEXT_PUBLIC_API_BASE_URL}${url}`,
                url: `${process.env.NEXT_PUBLIC_API_BASE_URL}${url}`,
                headers: { 'security-token': localStorage.getItem(LOCAL_STORAGE_TYPE.TOKEN) },
                data: payload !== null ? payload : null,
            });
            if (response.status === 200) {
                resolve(response.data)
            } else {
                reject(response);
            }
        } catch (error) {
            if (error.response.status === 401) {
                window.location.replace(`${process.env.NEXT_PUBLIC_URL}/login`);
            } else {
                reject(error);
            }
        }
    });
}

export async function axiosCall(method, url, payload = null, with_token = false) {
    return new Promise(async (resolve, reject) => {
        try {
            let token = localStorage.getItem(LOCAL_STORAGE_TYPE.TOKEN);
            let response = await axios({
                method: method,
                url: `${process.env.NEXT_PUBLIC_API_BASE_URL}${url}`,
                headers: token ? { 'security-token': token } : null,
                data: payload !== null ? payload : null,
                withCredentials: true
            });
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
}
 */